import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { toast } from "@/utils/toast";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/contexts/AuthContext";

export const NotFoundRedirect = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(["notFound"]);
  const { isLoggedIn, loading } = useAuth();

  useEffect(() => {
    if (loading || !isLoggedIn) {
      return;
    }
    toast.error(t("notFound:title"));
    navigate({ to: "/home", replace: true, search: null as never });
  });

  return null;
};
